export default {
  CREATE_NOTIFICATION(state, payload) {

  },
  GET_ALL_NOTIFICATION(state, payload) {
    state.push_notification = payload;
  },
  DELETE_NOTIFICATION(state, payload) {

  },
};
